import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectSectionComponent } from './select-section.component';
import { SharedModule } from '../../shared.module';
import { SectionsService } from '../../services/sections.service';

@NgModule({
    declarations: [SelectSectionComponent],
    imports: [CommonModule, SharedModule],
    exports: [SelectSectionComponent],
    providers: [SectionsService]
})
export class SelectSectionModule {}
